var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.892857 11.624C1.16071 11.624 1.39668 11.53 1.69005 11.3606L9.22194 7.07727C9.77041 6.7637 10 6.51912 10 6.12402C10 5.72893 9.77041 5.49061 9.22194 5.17077L1.69005 0.887421C1.39668 0.718094 1.16071 0.624023 0.892857 0.624023C0.369898 0.624023 0 1.01912 0 1.63999V10.6081C0 11.2352 0.369898 11.624 0.892857 11.624ZM1.3648 10.0687C1.33291 10.0687 1.3074 10.0374 1.3074 9.99346V2.25458C1.3074 2.20441 1.33291 2.17933 1.3648 2.17933C1.39031 2.17933 1.41582 2.19187 1.44133 2.21068L8.21429 6.05504C8.2398 6.07385 8.26531 6.09267 8.26531 6.12402C8.26531 6.15538 8.2398 6.17419 8.21429 6.19301L1.44133 10.0374C1.41582 10.0562 1.39031 10.0687 1.3648 10.0687Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.f140e85269c6f1bc2be57680c303097b.svg";
export { ForwardRef as ReactComponent };